var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0368 6.47921C10.0906 7.42629 9.55913 8.71075 9.55913 10.05C9.55913 11.3893 10.0906 12.6737 11.0368 13.6208C11.983 14.5679 13.2664 15.1 14.6046 15.1C15.9429 15.1 17.2263 14.5679 18.1724 13.6208C19.1186 12.6737 19.6501 11.3893 19.6501 10.05C19.6501 8.71075 19.1186 7.42629 18.1724 6.47921C17.2263 5.53212 15.9429 5 14.6046 5C13.2664 5 11.983 5.53212 11.0368 6.47921ZM17.3285 7.32312C18.051 8.04628 18.457 9.02717 18.457 10.05C18.457 11.0728 18.051 12.0537 17.3285 12.7769C16.6061 13.5 15.6262 13.9062 14.6046 13.9062C13.583 13.9062 12.6032 13.5 11.8807 12.7769C11.1583 12.0537 10.7523 11.0728 10.7523 10.05C10.7523 9.02717 11.1583 8.04628 11.8807 7.32312C12.6032 6.59996 13.583 6.19375 14.6046 6.19375C15.6262 6.19375 16.6061 6.59996 17.3285 7.32312Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9103 16.2812C9.09257 16.2812 6 19.3772 6 23.1979C6 23.9719 6.62713 24.6 7.40111 24.6H21.8082C22.5821 24.6 23.2093 23.9719 23.2093 23.1979C23.2093 19.3772 20.1167 16.2812 16.2989 16.2812H12.9103ZM7.40111 23.4062C7.28529 23.4062 7.19319 23.3145 7.19319 23.1979C7.19319 20.0383 9.75444 17.475 12.9103 17.475H16.2989C19.4548 17.475 22.0161 20.0383 22.0161 23.1979C22.0161 23.3145 21.924 23.4062 21.8082 23.4062H7.40111Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.b13cad1fef0bcdab5261721501a2be3d.svg";
export { ForwardRef as ReactComponent };